import { parseBoolean } from '@chatwoot/utils';
import OnboardingAPI from 'dashboard/api/onboarding';

const capture = (eventName, properties) => {
  const config = window.globalConfig;
  if (
    config?.DEPLOYMENT_ENV !== 'cloud' ||
    !parseBoolean(config.IS_ENTERPRISE)
  ) {
    return Promise.resolve(null);
  }

  const eventId = crypto.randomUUID();
  return OnboardingAPI.captureEvent({
    event_id: eventId,
    event_name: eventName,
    properties,
  }).catch(() => null);
};

export const captureOnboardingStepViewed = step =>
  capture('onboarding_step_viewed', { step });

export const captureOnboardingStepAttempted = step =>
  capture('onboarding_step_attempted', { step });

export const captureOnboardingStepCompleted = step =>
  capture('onboarding_step_completed', { step });

export const captureOnboardingStepError = (step, errorType) =>
  capture('onboarding_step_error', { step, error_type: errorType });

export const captureOnboardingChannelAction = (channelType, channelAction) =>
  capture('onboarding_channel_action', {
    channel_type: channelType,
    channel_action: channelAction,
  });
